import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Models } from '@ibexfusion/models';
import { ScreenSettingsService } from '@services/screen-settings/screen-settings.service';
import { LegacyCompositionService } from '@services/legacy-compositions/legacy-composition.service';
import { CompositionService } from '@services/compositions/composition.service';
import { DataTableEvent } from '../../../../components/data-table/data-table.component';
import { Router } from '@angular/router';
import { DialogService } from '@services/dialog/dialog.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { PrivilegeGuard } from '../../../../guards/privilege.guard';
import { JsonService } from '@services/jsons/json.service';

@Component({
    selector: 'app-code-snippets-screen-select',
    templateUrl: './code-snippets-screen-select.component.html',
    styleUrls: ['./code-snippets-screen-select.component.scss'],
    providers: [ScreenSettingsService, LegacyCompositionService, CompositionService, JsonService],
    standalone: false
})
export class CodeSnippetsScreenSelectComponent implements OnInit {

  public codeSnippet: Models.CodeSnippet;

  public paramsScreenSettingsAdded;
  public paramsScreenSettings;
  public columnsScreenSettings = [{ prop: 'detail.title', name: 'title' }, { prop: 'screenUuid' }];

  public paramsLegacyComposition;
  public columnsLegacyComposition = [{ prop: 'title', name: 'title' }, { prop: '_id' }];

  public paramsComposition;
  public columnsComposition = [{ prop: 'title', name: 'title' }, { prop: '_id' }];

  public paramsJsons;
  public columnsJsons = [{ prop: 'language', name: 'title' }, { prop: 'screenUUID' }];

  constructor(
    public screenSettingsService: ScreenSettingsService,
    public legacyCompositionService: LegacyCompositionService,
    public compositionService: CompositionService,
    public jsonService: JsonService,
    private router: Router,
    private dialogService: DialogService,
    private snackbar: SnackbarService,
    private dialogRef: MatDialogRef<CodeSnippetsScreenSelectComponent>,
    private priv: PrivilegeGuard,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    this.codeSnippet = this.data.codeSnippet;
    const excluded_pattern = '^((?!' + this.codeSnippet.name + ').)*$';

    this.paramsScreenSettings = { 'detail.pakVariant': 'standard', 'detail.codeSnippetNames': { $regex: excluded_pattern, $options: 's' } };
    this.paramsScreenSettingsAdded = { 'detail.codeSnippetNames': { $regex: this.codeSnippet.name } };
    this.paramsLegacyComposition = { 'codeSnippetNames': { $regex: this.codeSnippet.name } };
    this.paramsComposition = { 'snippetIds': this.codeSnippet._id };
    this.paramsJsons = { $and: [{ data: { $regex: this.codeSnippet.name } }] };

    this.compositionService.find(0, 100, {})
      .then(result => {

      });
  }

  public onDetailScreenSettings(event: DataTableEvent): void {
    console.log('navigate: ', event.row);
    this.router.navigate(['screen-settings', event.row.screenUuid]).then(() => {
      this.dialogRef.close();
    });
    if (this.priv.checkIfPrivilege('read', 'legacy-screen-settings')) {
      this.router.navigate(['screen-settings', event.row.screenUuid]).then(() => {
        this.dialogRef.close();
      });
    } else {
      console.log('not allowed');
    }
  }

  public onDetailLegacyComposition(event: DataTableEvent): void {
    if (this.priv.checkIfPrivilege('read', 'legacy-compositions')) {
      this.router.navigate(['legacy-compositions', event.row._id]).then(() => {
        this.dialogRef.close();
      });
    } else {
      console.log('not allowed');
    }
  }

  public onDetailComposition(event: DataTableEvent): void {
    if (this.priv.checkIfPrivilege('read', 'compositions')) {
      this.router.navigate(['compositions', event.row._id]).then(() => {
        this.dialogRef.close();
      });
    } else {
      console.log('not allowed');
    }
  }

  public onDetailJsons(event: DataTableEvent): void {
    if (this.priv.checkIfPrivilege('read', 'fakeJSONs')) {
      this.router.navigate(['jsons', event.row._id, 'detail']).then(() => {
        this.dialogRef.close();
      });
    } else {
      console.log('not allowed');
    }
  }

  public onAddToScreenSettings(event: DataTableEvent): void {
    event.row.detail.codeSnippetNames = event.row.detail.codeSnippetNames + '\n' + this.codeSnippet.name;
    this.screenSettingsService.update(event.row._id, event.row).then(result => {
      this.snackbar.success('Code Snippet added');
    });
  }

  public onRemoveFromScreenSettings(event: DataTableEvent): void {
    this.dialogService.confirm('Remove Code Snippet from Screen ' + event.row.detail.title + '?')
      .then(res => {
        if (!res) {
          return;
        }
        this.removeSnippet(event.row, true);
      });
  }

  public removeSnippet(entry, showInfo) {
    const array = entry.detail.codeSnippetNames.split('\n');
    const index = array.indexOf(this.codeSnippet.name);
    if (index > -1) {
      array.splice(index, 1);
    }
    entry.detail.codeSnippetNames = array.join('\n');
    this.screenSettingsService.update(entry._id, entry).then(result => {
      if (showInfo) {
        this.snackbar.success('Code Snippet removed');
      }
    });
  }

  public removeFromAllScreens() {
    this.dialogService.confirm('Are you sure, you want to remove this snippet from all screens?')
      .then(res => {
        if (!res) {
          return;
        }
        this.screenSettingsService.find(0, 100, { 'detail.codeSnippetNames': { $regex: this.codeSnippet.name } })
          .then(result => {
            if (result && result.data && result.data.length) {
              result.data.map(entry => {
                this.removeSnippet(entry, false);
              });
              this.snackbar.success('Removing snippet from all screens');
            }
          });
      });
  }
}
